import { Injectable, isDevMode } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from '../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  /**
   *
   */
  appInsights: ApplicationInsights;
  /**
   *
   */
  constructor() {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: environment.appInsights.instrumentationKey,
        enableAutoRouteTracking: true, // option to log all route changes
        disableTelemetry: isDevMode(),
      },
    });
    this.appInsights.loadAppInsights();
  }
  /**
   *
   * @param name
   * @param url
   */
  logPageView(name?: string, url?: string) {
    // option to call manually
    this.appInsights.trackPageView({
      name: name,
      uri: url,
    });
  }
  /**
   *
   * @param name
   * @param properties
   */
  logEvent(name: string, properties?: { [key: string]: any }) {
    this.appInsights.trackEvent({ name: name }, properties);
  }
  /**
   *
   * @param name
   * @param average
   * @param properties
   */
  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    this.appInsights.trackMetric({ name: name, average: average }, properties);
  }
  /**
   *
   * @param exception
   * @param severityLevel
   */
  logException(exception: Error, severityLevel?: number) {
    this.appInsights.trackException({
      exception: exception,
      severityLevel: severityLevel,
    });
  }
  /**
   *
   * @param message
   * @param properties
   */
  logTrace(message: string, properties?: { [key: string]: any }) {
    this.appInsights.trackTrace({ message: message }, properties);
  }
}
